//进口单详情
const orderDetailData = {
  boxLines: [
    {
      rowList: [
        { title: "型号: ", banding: "PartNo", value: "" },
        { title: "品名: ", banding: "ProductName", value: "" },
        { title: "品牌: ", banding: "Brand", value: "" }
      ]
    },
    {
      rowList: [
        {
          title: "数量: ",
          banding: "Quantity",
          value: "",
          dataType: "Number",
          className: "c-unAmount-color"
        },
        {
          title: "单价: ",
          banding: "UnitPrice",
          value: "",
          dataType: "Number",
          className: "c-unAmount-color"
        },
        { title: "单位: ", banding: "Unit", value: "" }
      ]
    },
    {
      rowList: [
        {
          title: "关税: ",
          banding: "TariffFee",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        },
        {
          title: "增值税: ",
          banding: "VATFee",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        },
        {
          title: "总价: ",
          banding: "Amount",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        }
      ]
    },
    {
      rowList: [
        { title: "毛重: ", banding: "ClientWeight", value: "" }
        // { title: "净重: ", banding: "ClientNetWeight", value: "" },
        // { title: "商检类型: ", banding: "InspectionType", value: "" }
      ]
    }
  ]
};

const hkOrderDetailData = {
  boxLines: [
    {
      rowList: [
        { title: "型号：", banding: "PartNo", value: "" },
        { title: "品名：", banding: "ProductName", value: "" },
        { title: "品牌", banding: "Brand", value: "" }
      ]
    },
    {
      rowList: [
        { title: "年份: ", banding: "MakeAge", value: "" },
        {
          title: "数量: ",
          banding: "Quantity",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        },
        { title: "净重: ", banding: "NetWeight", value: "" }
      ]
    },
    {
      rowList: [
        {
          title: "买入价: ",
          banding: "UnitPrice",
          value: "",
          dataType: "Number",
          className: "c-unAmount-color"
        },
        {
          title: "卖出价: ",
          banding: "SellPrice",
          value: "",
          dataType: "Number",
          className: "c-unAmount-color"
        },
        { title: "毛重: ", banding: "Weight", value: "" }
      ]
    },
    {
      rowList: [
        {
          title: "买入金额: ",
          banding: "Amount",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        },
        {
          title: "卖出金额: ",
          banding: "SellAmount",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        },
        { title: "", banding: "", value: "" }
      ]
    }
  ]
};

const hkStockDetailData = {
  boxLines: [
    {
      rowList: [{ title: "本港单号: ", banding: "AgentOrderNo", value: "", className: 'c-code-color' }]
    },
    {
      rowList: [
        { title: "型号：", banding: "PartNo", value: "" },
        { title: "品名：", banding: "ProductName", value: "" },
        { title: "品牌", banding: "Brand", value: "" }
      ]
    },

    {
      rowList: [
        { title: "年份: ", banding: "MakeAge", value: "" },
        {
          title: "出库数量: ",
          banding: "OutQuantity",
          value: "",
          dataType: "Number",
          className: "c-amount-color"
        }
      ]
    }
  ]
};

export { orderDetailData, hkOrderDetailData, hkStockDetailData };
